import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { STORAGE_KEYS as s } from "./storage-manager.js";
import u from "./subscription-manager.js";
import { logger as E, IndexedDBAdapter as et } from "../../shared-lib/index.js";
var Bt = /*#__PURE__*/function () {
  function Bt(t, i, s) {
    _classCallCheck(this, Bt);
    this.j = t, this.Zn = i, this.gh = s, this.j = t, this.Zn = i || !1, this.gh = s, this.ph = new u(), this.Fh = 0, this.kh = 1;
  }
  _createClass(Bt, [{
    key: "fh",
    value: function fh() {
      return this.Zn;
    }
  }, {
    key: "wh",
    value: function wh() {
      return this.j.lt(s.ct.jh);
    }
  }, {
    key: "setSdkAuthenticationSignature",
    value: function setSdkAuthenticationSignature(t) {
      var i = this.wh();
      this.j.ft(s.ct.jh, t);
      var e = et.Us.Rs;
      new et(e, E).setItem(e.Fs.xh, this.kh, t), i !== t && this.Z();
    }
  }, {
    key: "qh",
    value: function qh() {
      this.j.Nt(s.ct.jh);
      var t = et.Us.Rs;
      new et(t, E).be(t.Fs.xh, this.kh);
    }
  }, {
    key: "subscribeToSdkAuthenticationFailures",
    value: function subscribeToSdkAuthenticationFailures(t) {
      return this.gh.wt(t);
    }
  }, {
    key: "yh",
    value: function yh(t) {
      this.gh.L(t);
    }
  }, {
    key: "Bh",
    value: function Bh() {
      this.ph.removeAllSubscriptions();
    }
  }, {
    key: "Gh",
    value: function Gh() {
      this.Fh += 1;
    }
  }, {
    key: "Hh",
    value: function Hh() {
      return this.Fh;
    }
  }, {
    key: "Z",
    value: function Z() {
      this.Fh = 0;
    }
  }]);
  return Bt;
}();
export { Bt as default };